import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Modal from "@mui/material/Modal"
import CloseIcon from "@mui/icons-material/Close"
import { ButtonContainer, CancelButton, ConfirmButton, ModalHeader } from "./Atom"
import { modalContainerStyles } from "../Atom"

type Props = {}

const MyInfoConfirmation = (props: any) => {

    const { open, setOpen, currentContactNumber, newContactNumber, setContactNumberValue, setIsContactNumberEditActive, updateUserContactNumber } = props

    const handleClose = () => {
        setContactNumberValue("");
        setIsContactNumberEditActive(false);
        setOpen(false);
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="groupInfo-modal-title"
            aria-describedby="groupInfo-modal-description"
        >
            <Box sx={modalContainerStyles}>

                <ModalHeader>
                    <CloseIcon
                        sx={{ marginRight: "10px", marginTop: "10px", cursor: "pointer" }}
                        onClick={() => {
                            handleClose()
                        }}
                    />
                </ModalHeader>

                <Typography
                    id="modal-modal-title"
                    fontSize={"18px"}
                    fontWeight={500}
                    sx={{ padding: "10px 10px 30px 10px", textAlign: "center", borderBottom: "1px solid grey" }}
                >
                    Are you sure to change your contact number from <b>{currentContactNumber ? `"${currentContactNumber}"` : `No Number`}</b>  to <b>{`"${newContactNumber}"`}</b>?

                </Typography>

                <br />
                {/* <Divider /> */}

                <ButtonContainer
                >
                    <CancelButton
                        onClick={() => handleClose()}
                    >
                        <Typography color={"#4A79E7"}>Cancel</Typography>
                    </CancelButton>
                    <ConfirmButton
                        onClick={async () => {
                            updateUserContactNumber(newContactNumber);
                            handleClose();
                        }}
                    >
                        <Typography color={"#ffffff"}>Yes</Typography>
                    </ConfirmButton>
                </ButtonContainer>
            </Box>
        </Modal>
    )
}

export default MyInfoConfirmation